import React from 'react';
import PropTypes from 'prop-types';
import CheckoutModal from '../containers/CheckoutModal';
import { FontsPreloader } from './CheckoutModal';
import { nullFunc } from '../../utils/helpers';

const CheckoutButton = ({
  disabled,
  className,
  panelLabel,
  children,
  on,
  off,
  formDisabled,
  onSuccess,
  toggled,
  action,
  showPromo,
  onBeforeOpen,
  onBeforeClose,
}) => (
  <div>
    <FontsPreloader />
    <button
      className={className}
      type="button"
      disabled={disabled || formDisabled}
      onClick={on}
    >
      {children}
    </button>
    <CheckoutModal
      onSuccess={onSuccess}
      off={off}
      panelLabel={panelLabel}
      toggled={toggled}
      action={action}
      showPromo={showPromo}
      onBeforeOpen={onBeforeOpen}
      onBeforeClose={onBeforeClose}
    />
  </div>
);

CheckoutButton.propTypes = {
  formDisabled: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  toggled: PropTypes.bool.isRequired,
  onSuccess: PropTypes.func.isRequired,
  className: PropTypes.string,
  panelLabel: PropTypes.string,
  children: PropTypes.node.isRequired,
  on: PropTypes.func.isRequired,
  off: PropTypes.func.isRequired,
  action: PropTypes.string,
  showPromo: PropTypes.bool,
  onBeforeOpen: PropTypes.func,
  onBeforeClose: PropTypes.func,
};

CheckoutButton.defaultProps = {
  className: '',
  action: '',
  panelLabel: '',
  showPromo: false,
  onBeforeOpen: nullFunc,
  onBeforeClose: nullFunc,
};

export default CheckoutButton;



// WEBPACK FOOTER //
// ./src/app/reservation/components/CheckoutButton.jsx